// Module
var code = "<script>let $ctrl</script> <molecule-panel-wizard panel-title=\"{{ 'DOMAIN.DIRECTIVES.HANDLE-CHOOSER.BUTTONS.ADD.TITLE' | translate }}\"> <panel-body> <molecule-panel-contact-content mode=\"2\" contact=\"$ctrl.contact\"></molecule-panel-contact-content> </panel-body> </molecule-panel-wizard> ";
// Exports
module.exports = code;